import './DataAccessSearch.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataAccessSearch } from './DataAccessSearch';
import React from 'react';
import { SonarCard } from '@ui/general';

export const DataAccess: React.FC = () =>
	<SonarCard title={ COPY_SPECIFIC.DATA_ACCESS }>
		<DataAccessSearch
			showCompare
			showRecent />
	</SonarCard>;
